import { FC } from "react";
import NotFoundPageIconSVG from "../../resources/svg/NotFoundPageIconSVG";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectUser } from "../../../slices/user-slice";
import { Link } from "react-router-dom";

const NotFoundPage: FC = () => {
    const user = useSelector(selectUser());
    const { t } = useTranslation();

    return (
        <div
            className={`relative ${
                user?.id ? "h-[calc(100vh-108px)]" : "h-[calc(100vh-68px)]"
            } min-h-[450px] mb-[80px]`}
        >
            <div className="flex flex-col justify-center items-center h-full">
                <NotFoundPageIconSVG className="ti9:w-[400px] ti9:h-[300px] tmax4:w-[250px] tmax4:h-[190px]" />
                <div className="flex flex-col justify-center items-center w-[403px] dmax2:w-[336px] mt-10">
                    <p className="H24B dmax2:H20B text-textWhite text-center">{t("errors.notFound1")}</p>
                    <p className="H24B dmax2:H20B text-textWhite text-center">{t("errors.notFound2")}</p>
                    <Link
                        to="/"
                        className="button H16B dmax2:H14B w-[248px] dmax2:w-[207px] h-[50px] dmax2:h-[40px] mt-10 dmax2:mt-6"
                    >
                        {t("errors.notFoundButton")}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
